import { FC } from 'react';
import cn from 'classnames';
import { SvgProps } from './types';

const WhatsappIcon: FC<SvgProps> = ({
  className,
  width = '20',
  height = '20',
  viewBox = '0 0 20 20',
}) => {
  return (
    <svg
      className={cn(className)}
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
        fill="url(#paint0_linear_1623_34017)"
      />
      <path
        d="M14.2866 5.7092C13.2587 4.67038 11.8877 4.04147 10.4298 3.94004C8.97197 3.83862 7.52707 4.27163 6.36527 5.15811C5.20347 6.0446 4.40429 7.32387 4.11716 8.75677C3.83003 10.1897 4.0746 11.6781 4.80514 12.9438L3.95056 16.0506L7.14399 15.2169C8.02797 15.6959 9.01747 15.9467 10.0229 15.9466H10.0254C11.6185 15.9481 13.1472 15.3178 14.2764 14.194C15.4056 13.0703 16.0432 11.5446 16.0494 9.95149C16.0516 9.16293 15.8968 8.38181 15.5942 7.65363C15.2915 6.92546 14.847 6.26478 14.2866 5.71006V5.7092ZM10.026 14.9332H10.024C9.12778 14.9334 8.24785 14.6936 7.47571 14.2386L7.29286 14.1306L5.39771 14.6255L5.90342 12.7866L5.78428 12.5981C5.19068 11.6583 4.92636 10.5479 5.03289 9.44146C5.13942 8.33505 5.61077 7.29546 6.37277 6.48623C7.13477 5.677 8.14418 5.14407 9.2422 4.97128C10.3402 4.79848 11.4645 4.99564 12.4382 5.53172C13.4119 6.0678 14.1798 6.91238 14.621 7.9326C15.0622 8.95281 15.1517 10.0908 14.8754 11.1674C14.5991 12.244 13.9728 13.1983 13.0948 13.88C12.2169 14.5617 11.1372 14.9322 10.0257 14.9332H10.026ZM12.7717 11.2009C12.6211 11.1261 11.8811 10.7635 11.7431 10.7135C11.6051 10.6635 11.5049 10.6386 11.4046 10.7883C11.3043 10.9381 11.0157 11.2758 10.928 11.3758C10.8403 11.4758 10.7523 11.4883 10.602 11.4132C10.1585 11.2376 9.74883 10.9863 9.39142 10.6703C9.06248 10.3678 8.78026 10.0181 8.55399 9.63264C8.46628 9.48264 8.54457 9.40149 8.62 9.32692C8.68771 9.25978 8.77057 9.15206 8.84571 9.06435C8.90763 8.98866 8.95833 8.90447 8.99628 8.81435C9.01628 8.77301 9.02562 8.72733 9.02342 8.68146C9.02122 8.6356 9.00757 8.591 8.98371 8.55177C8.946 8.47691 8.64513 7.73949 8.51971 7.43949C8.39742 7.14749 8.27342 7.18692 8.18114 7.18234C8.09342 7.17806 7.99286 7.1772 7.89257 7.1772C7.81661 7.17934 7.74189 7.19708 7.67308 7.22932C7.60426 7.26157 7.54282 7.30762 7.49256 7.36463C7.32256 7.52476 7.18789 7.71865 7.09716 7.93385C7.00643 8.14906 6.96166 8.38083 6.96571 8.61434C7.01485 9.17984 7.22849 9.71858 7.58028 10.1641C7.65542 10.2641 8.64171 11.7772 10.1517 12.4261C10.4317 12.5458 10.7178 12.6507 11.0089 12.7403C11.316 12.8332 11.6405 12.8536 11.9568 12.7998C12.246 12.7566 12.8474 12.4375 12.9728 12.0875C13.0713 11.8638 13.1018 11.6161 13.0606 11.3752C13.0229 11.3126 12.9226 11.2752 12.772 11.2003L12.7717 11.2009Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1623_34017"
          x1="10"
          y1="0"
          x2="10"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#56F06C" />
          <stop offset="1" stop-color="#2FBC2C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WhatsappIcon;
